import { h } from 'preact';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useState, useEffect } from 'preact/hooks';

import { MQUERY } from 'common/constants';
import translator from 'common/i18n';
import { socialHelpers, FACEBOOK, WHATSAPP, FACEBOOK_MESSENGER } from 'common/helpers/social';

import ShareIcon from 'svg-files/icons/share.svg';
import FacebookIcon from 'svg-files/icons/facebook.svg';
import MessengerIcon from 'svg-files/icons/facebook-messenger.svg';
import WhatsappIcon from 'svg-files/icons/whatsapp.svg';
import LinkIcon from 'svg-files/icons/link.svg';

export default function ShareButtons({ className, text, shareText, accessibilityDarkMode }) {
    const [shareOpen, setShareOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    const [copyText, setCopyText] = useState('');

    const handleShareToggleClick = () => {
        setShareOpen(!shareOpen);
    };

    const handleShareBtnClick = service => {
        socialHelpers[service].sharePage(shareText);
    };

    const handleOnCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
    };

    useEffect(() => {
        setCopyText(`${window.location.href}?utm_source=share_button&utm_medium=onsite_url`);
    }, []);

    return (
        <InteractionCta className={className} onClick={handleShareToggleClick} darkMode={accessibilityDarkMode}>
            <InteractionButton>
                <ShareIcn />
            </InteractionButton>

            {copied ? translator.lookup('label.share.url-copied') : text }

            <ShareContainer visible={shareOpen.toString()}>
                <ShareButton onClick={() => handleShareBtnClick(FACEBOOK)}>
                    <FacebookIcon />
                    <ShareLabel>Facebook</ShareLabel>
                </ShareButton>

                <ShareButton onClick={() => handleShareBtnClick(FACEBOOK_MESSENGER)} hideDesktop="yep">
                    <MessengerIcon />
                    <ShareLabel>Facebook Messenger</ShareLabel>
                </ShareButton>

                <ShareButton onClick={() => handleShareBtnClick(WHATSAPP)} hideDesktop="yep">
                    <WhatsappIcon />
                    <ShareLabel>Whatsapp</ShareLabel>
                </ShareButton>

                <CopyToClipboard text={copyText} onCopy={handleOnCopy}>
                    <ShareButton>
                        <LinkIcon />
                        <ShareLabel>{translator.lookup('label.share.copy-link')}</ShareLabel>
                    </ShareButton>
                </CopyToClipboard>
            </ShareContainer>
        </InteractionCta>
    );
}

const ShareContainer = styled.div`
    position: absolute;
    display: flex;
    left: 0;
    bottom: 115%;
    padding: 0.8rem 2rem 0.4rem;
    background-color: var(--button);
    border-radius: 24px;
    transform: ${({ visible }) => (visible === 'true' ? 'translateX(0)' : 'translateX(-250%)')};
    transition: transform 0.35s ease, opacity 0.35s ease;
    z-index: 1;

    @media ${MQUERY.DESKTOP_SMALL} {
        opacity: ${({ visible }) => (visible === 'true' ? '1' : '0')};
        visibility: ${({ visible }) => (visible === 'true' ? 'visible' : 'hidden')};
    }
`;

const ShareButton = styled.button`
    padding: 0;
    margin-right: 1.2rem;
    background: none;
    border: none;
    cursor: pointer;

    svg {
        fill: var(--primaryDark);
    }

    &:last-child {
        margin-right: 0;
    }

    @media ${MQUERY.DESKTOP_SMALL} {
        display: ${({ hideDesktop }) => (hideDesktop === 'yep' ? 'none' : 'inline-flex')};
    }
`;

const ShareLabel = styled.span`
    display: inline-block;
    position: absolute;
    left: -999rem;
`;

const InteractionCta = styled.div`
    color: ${ ( { darkMode } ) => ( darkMode ? 'var(--white)' : 'var(--neutral800)' )};
    position: relative;
    display: inline-flex;
    align-items: center;
    transition: color 0.25s ease;
    cursor: pointer;
    user-select: none;

    &:hover {
        color: var(--button);
    }

    &:first-child {
        margin-right: 2.4rem;
    }

    &.video-player {
        color: var(--text);   
    }

    @media ${MQUERY.DESKTOP_SMALL} {
        &.video-player {
            color: var(--white);   


            &:hover {
                color: var(--button);
            }
        }
    }
`;

const InteractionButton = styled.div`
    display: flex;
    margin-right: 0.8rem;
    width: 3.2rem;
    height: 3.2rem;
    align-items: center;
    justify-content: center;
    border: 2px solid currentColor;
    border-radius: 100%;
    transition: border-color 0.25s ease;

    ${InteractionCta}:hover & {
        border-color: var(--button);
    }
`;

const ShareIcn = styled( ShareIcon )`
    fill: currentColor;
    transition: fill 0.25s ease;

    ${InteractionCta}:hover & {
        fill: var(--button);
    }
`;
